import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { Container, Button, Row, Col, Form, Spinner } from 'react-bootstrap';

const AnswerFragment = () => {
    const [ratingsData, setRatingsData] = useState([]);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const [loading, setLoading] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [courses, setCourses] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState('');
    const [selectedCourse, setSelectedCourse] = useState('');

    useEffect(() => {
        fetchCompanies();
    }, []);

    useEffect(() => {
        fetchData(currentPage);
    }, [currentPage]);

    const fetchCompanies = async () => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", localStorage.getItem('token'));
        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow"
        };
        fetch("https://beiguru.co.in/admin/companies", requestOptions)
            .then((response) => {
                if (response.status == 401) {
                    localStorage.clear();
                    window.location.reload();
                    return [];
                } else {
                    return response.json()
                }
            })
            .then((result) => setCompanies(result))
            .catch((error) => console.error(error));
    }

    const fetchCourses = async (company, isFilter) => {
        console.log(company);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", localStorage.getItem('token'));
        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow"
        };
        fetch(`https://beiguru.co.in/admin/courses-company/${company}`, requestOptions)
            .then((response) => {
                if (response.status == 401) {
                    localStorage.clear();
                    window.location.reload();
                    return [];
                } else {
                    return response.json()
                }
            })
            .then((result) => setCourses(result))
            .catch((error) => console.error(error));
    }

    const fetchData = async (currentPage) => {
        setLoading(true);
        try {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", localStorage.getItem('token'));
            const requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow"
            };
            let apiUrl = `https://beiguru.co.in/answers?page=${currentPage}&pageSize=10`;
            // if (selectedCompany) {
            //     apiUrl += `&companyId=${selectedCompany}`; // Append company ID if selected
            // }
            // if (selectedCourse) {
            //     apiUrl += `&courseId=${selectedCourse}`; // Append company ID if selected
            // }
            const response = await fetch(apiUrl, requestOptions);
            const data = await response.json();
            console.log(data);
            setRatingsData(data.answers);
            setTotalPage(data.totalPages);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    return (
        <Grid item xs={10} style={{ padding: '20px', height: '100%', fontFamily: "Noto Sans", fontWeight: '500', justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
            <Container fluid style={{ height: '100%', }}>
                <Row>
                    <Col style={{ flex: 1, height: '90vh', width: '100%', display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'space-between' }}>
                        <div style={{ width: '100%' }}>
                            {/* <div style={{ display: 'flex', width: '100%', flexDirection: 'row', marginBottom: '10px' }}>
                                <Form.Group controlId="formCompanyFilter" style={{ flex: 1 }}>
                                    <Form.Control
                                        className="w-100"
                                        style={{ width: '100%', borderRadius: '10px' }}
                                        as="select"
                                        value={selectedCompany}
                                        onChange={(e) => {
                                            setSelectedCompany(e.target.value);
                                            setSelectedCourse('');
                                            setCurrentPage(1);
                                            fetchCourses(e.target.value, true);
                                        }}>
                                        <option value="">All Companies</option>
                                        {companies.map(company => (
                                            <option key={company._id} value={company._id}>{company.name}</option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>
                                <div style={{ width: '20px' }} />
                                <Form.Group controlId="formCompanyFilter" style={{ flex: 1 }}>
                                    <Form.Control
                                        className="w-100"
                                        style={{ width: '100%', borderRadius: '10px' }}
                                        as="select"
                                        value={selectedCourse}
                                        onChange={(e) => {
                                            setSelectedCourse(e.target.value);
                                            setCurrentPage(1);
                                        }}>
                                        <option value="">All Courses</option>
                                        {courses.map(company => (
                                            <option key={company._id} value={company._id}>{company.title}</option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>
                            </div>
                            <div style={{ height: '10px' }} /> */}
                            {ratingsData.length > 0 ? <table style={{ flex: 1, display: 'flex', flexDirection: 'column', }} className="table table-striped table-bordered table-hover">
                                <thead>
                                    <tr style={{ flex: 1, display: 'flex', flexDirection: 'row', }} >
                                        <td style={{ flex: 1 }}>Students</td>
                                        <td style={{ flex: 1 }}>Course</td>
                                        <td style={{ flex: 1 }}>Material</td>
                                        <td style={{ flex: 1 }}>Quiz</td>
                                        <td style={{ flex: 3 }}>Answer</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {ratingsData.map((item) => {
                                        const material = item.courseID.videosWithQuizzes.find((element) => element._id == item.materialID);
                                        const quiz = material ? material.quiz.find((element) => element._id == item.quizID) : null;
                                        return (<tr key={item._id} style={{ '&:hover': { backgroundColor: '#f5f5f5' }, flex: 1, display: 'flex', flexDirection: 'row', }}>
                                            <td style={{ flex: 1 }}>{item.employeeID.firstName} {item.employeeID.lastName}</td>
                                            <td style={{ flex: 1 }}>{item.courseID.title}</td>
                                            <td style={{ flex: 1 }}>{material ? material.video.title : ''}</td>
                                            <td style={{ flex: 1 }}>{quiz ? quiz.question : ''}</td>
                                            <td style={{ flex: 3 }}>{item.answer}</td>
                                        </tr>);
                                    })}
                                </tbody>
                            </table>
                                : <div style={{ margin: '20px', textAlign: 'center' }}>No answers found, please try again!</div>}
                        </div>
                        <div style={{ flex: 1 }}></div>
                        <nav aria-label="Courses pagination">
                            <ul className="pagination">
                                {[...Array(totalPage).keys()].map((page) => (
                                    <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                                        <button className="page-link" onClick={() => handlePageChange(page + 1)}>
                                            {page + 1}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </Col>
                </Row>
            </Container>
        </Grid >
    );
};

export default AnswerFragment;